export enum PlanType {
  FREE = 'free',
  PRO = 'pro',
  PREMIUM = 'premium',
  ENTERPRISE = 'enterprise',
  ENTERPRISE_PENDING = 'enterprise_pending',
}

export interface SubscriptionPlan {
  id: PlanType
  name: string
  price: number | null // null for free and custom pricing
  currency: string
  billingPeriod: 'month' | 'year' | null
  description: string
  features: string[]
  recommended?: boolean
  ctaText: string
  badge?: string
}

export interface EnterpriseFormData {
  companyName: string
  contactName: string
  email: string
  phoneNumber?: string
  teamSize: string
  industry?: string
  needs: string
  additionalInfo?: string
  modules?: string[]
}

export interface UserSubscription {
  userId: string
  plan: PlanType
  startDate: string
  endDate?: string
  trialEndsAt?: string
  isTrial?: boolean
  status: 'active' | 'trial' | 'pending' | 'cancelled' | 'expired'
}
